const l = `.sl-accordion{background:var(--sl-accordion-bg,hsl(var(--sl-hsl-card)));border:1px solid var(--sl-accordion-border-color,hsl(var(--sl-hsl-border)));border-radius:var(--sl-accordion-border-radius,var(--sl-radius-md,0.5rem));overflow:hidden}.sl-accordion--flush-start{border-left:none;border-radius:0;border-top-right-radius:var(--sl-accordion-border-radius,var(--sl-radius-md,0.5rem));border-bottom-right-radius:var(--sl-accordion-border-radius,var(--sl-radius-md,0.5rem))}.sl-accordion--flush-end{border-right:none;border-radius:0;border-top-left-radius:var(--sl-accordion-border-radius,var(--sl-radius-md,0.5rem));border-bottom-left-radius:var(--sl-accordion-border-radius,var(--sl-radius-md,0.5rem))}.sl-accordion--flush-full{border:none;border-radius:0}.sl-accordion-item__summary{display:flex;align-items:center;justify-content:space-between;padding:var(--sl-accordion-item-padding,var(--sl-spacing-4,1rem));margin:0;font-weight:var(--sl-font-weight-semibold,600);color:var(--sl-accordion-item-title-color,hsl(var(--sl-hsl-foreground)));cursor:pointer;list-style:none;user-select:none;transition:background-color var(--sl-accordion-transition,var(--sl-transition-normal,200ms)) ease}.sl-accordion-item__summary::-webkit-details-marker{display:none}.sl-accordion-item__summary::after{content:'';display:inline-block;width:0.75rem;height:0.75rem;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'%3E%3Cpath fill-rule='evenodd' d='M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z' clip-rule='evenodd'/%3E%3C/svg%3E");background-size:contain;background-repeat:no-repeat;transition:transform var(--sl-accordion-transition,var(--sl-transition-normal,200ms)) ease;flex-shrink:0}details[open] > .sl-accordion-item__summary::after{transform:rotate(180deg)}.sl-accordion-item__summary:hover{background:hsl(var(--sl-hsl-muted))}.sl-accordion-item__content{padding:var(--sl-accordion-item-content-padding,var(--sl-spacing-5,1.25rem));border-top:1px solid var(--sl-accordion-border-color,hsl(var(--sl-hsl-border)));background:var(--sl-accordion-item-bg,hsl(var(--sl-hsl-card)));color:inherit}details[open] > .sl-accordion-item__summary{background:hsl(var(--sl-hsl-muted));border-bottom:none}.sl-accordion--flush-full .sl-accordion-item__summary{border:none}@media (prefers-reduced-motion:reduce){.sl-accordion-item__summary,.sl-accordion-item__summary::after{transition:none}}`;
class d extends HTMLElement {
  constructor() {
    super(), this._toggleHandler = null, this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  static get observedAttributes() {
    return ["multiple", "flush"];
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._render();
  }
  get multiple() {
    return this.hasAttribute("multiple");
  }
  set multiple(e) {
    e ? this.setAttribute("multiple", "") : this.removeAttribute("multiple");
  }
  get flush() {
    return this.getAttribute("flush") || "none";
  }
  set flush(e) {
    this.setAttribute("flush", e);
  }
  /**
   * Programmatically open an item by index.
   * @param index - Index of the item to open
   */
  openItem(e) {
    const t = this._getItems();
    if (e < 0 || e >= t.length) return;
    const s = t[e];
    this.multiple || t.forEach((r, i) => {
      i !== e && r.open && (r.open = !1, this._dispatchClose(r, i));
    }), s.open = !0, this._dispatchOpen(s, e);
  }
  /**
   * Programmatically close an item by index.
   * @param index - Index of the item to close
   */
  closeItem(e) {
    const t = this._getItems();
    if (e < 0 || e >= t.length) return;
    const s = t[e];
    s.open && (s.open = !1, this._dispatchClose(s, e));
  }
  _getItems() {
    return Array.from(this.querySelectorAll("sl-accordion-item"));
  }
  _dispatchOpen(e, t) {
    this.dispatchEvent(
      new CustomEvent("sl-accordion-item-open", {
        bubbles: !0,
        composed: !0,
        detail: { index: t, item: e }
      })
    );
  }
  _dispatchClose(e, t) {
    this.dispatchEvent(
      new CustomEvent("sl-accordion-item-close", {
        bubbles: !0,
        composed: !0,
        detail: { index: t, item: e }
      })
    );
  }
  _handleItemToggle(e) {
    const s = e.composedPath().find((o) => o.tagName === "SL-ACCORDION-ITEM");
    if (!s) return;
    const r = this._getItems(), i = r.indexOf(s);
    i !== -1 && (this.multiple || r.forEach((o, a) => {
      a !== i && o.open && (o.open = !1, this._dispatchClose(o, a));
    }));
  }
  connectedCallback() {
    this._toggleHandler = (e) => this._handleItemToggle(e), this.addEventListener("click", this._toggleHandler);
  }
  disconnectedCallback() {
    this._toggleHandler && (this.removeEventListener("click", this._toggleHandler), this._toggleHandler = null);
  }
  _render() {
    const e = this.flush !== "none" ? ` sl-accordion--flush-${this.flush}` : "";
    this._shadow.innerHTML = `
      <style>${l}</style>
      <div class="sl-accordion${e}">
        <slot></slot>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-accordion") && customElements.define("sl-accordion", d);
class c extends HTMLElement {
  static get observedAttributes() {
    return ["open", "disabled"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" });
    const e = document.createElement("div");
    e.innerHTML = `<style>${l}</style>`, this._details = document.createElement("details");
    const t = document.createElement("summary");
    t.className = "sl-accordion-item__summary";
    const s = document.createElement("slot");
    s.setAttribute("name", "title"), t.appendChild(s);
    const r = document.createElement("div");
    r.className = "sl-accordion-item__content", r.setAttribute("part", "content"), r.appendChild(document.createElement("slot")), this._details.appendChild(t), this._details.appendChild(r), e.appendChild(this._details), this._shadow.appendChild(e), t.addEventListener("click", (i) => {
      this.disabled && i.preventDefault();
    });
  }
  connectedCallback() {
    this.hasAttribute("open") && (this._details.open = !0);
  }
  attributeChangedCallback(e, t, s) {
    t !== s && (e === "open" ? this._details.open = s !== null : e === "disabled" && this._updateDisabled());
  }
  get open() {
    return this._details.open;
  }
  set open(e) {
    this._details.open = e, e ? this.setAttribute("open", "") : this.removeAttribute("open");
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled"), this._updateDisabled();
  }
  _updateDisabled() {
    const e = this._shadow.querySelector(".sl-accordion-item__summary");
    e && (this.disabled ? (e.style.pointerEvents = "none", e.style.opacity = "0.5") : (e.style.pointerEvents = "", e.style.opacity = ""));
  }
}
typeof customElements < "u" && !customElements.get("sl-accordion-item") && customElements.define("sl-accordion-item", c);
export {
  d as SlAccordionElement,
  c as SlAccordionItemElement
};
//# sourceMappingURL=sl-accordion.js.map
